import { SignFlowRef } from '@src/features/DocumentSign/SignFlow';

import { RefObject, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useEgovMobileSignCheckProgress<T>({
    signRef,
    enabled = true,
}: {
    signRef: RefObject<SignFlowRef<T> | null>;
    enabled?: boolean;
}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const mobileSignSessionId = searchParams.get('mobileSignSessionId');

    const removeMobileSignSessionId = useCallback(() => {
        setSearchParams(
            (currentParams) => {
                const newParams = new URLSearchParams(currentParams);
                newParams.delete('mobileSignSessionId');
                return newParams;
            },
            { replace: true },
        );
    }, [setSearchParams]);

    useEffect(() => {
        if (enabled && mobileSignSessionId) {
            signRef.current?.checkingStatusSignBySessionId?.(
                mobileSignSessionId,
            );
        }
    }, [enabled, mobileSignSessionId, signRef]);

    return { removeMobileSignSessionId, mobileSignSessionId };
}
